function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "VOD-to-Live-ready-to-go",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Uploading_succeeded",
  transform: "translate(-1140.000000, -520.000000)",
  fill: "#1D1D1D"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(700.000000, 364.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "row-3-copy",
  transform: "translate(0.000000, 88.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Button-Icon-Only/buttonIconOnly",
  transform: "translate(436.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/refresh",
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,1.33333333 C11.6818983,1.33333333 14.6666667,4.31810167 14.6666667,8 C14.6666667,8.36818983 14.3681898,8.66666667 14,8.66666667 C13.6318102,8.66666667 13.3333333,8.36818983 13.3333333,8 C13.3333333,5.05448133 10.9455187,2.66666667 8,2.66666667 C5.05448133,2.66666667 2.66666667,5.05448133 2.66666667,8 C2.66666667,10.9455187 5.05448133,13.3333333 8,13.3333333 C9.64544585,13.3333333 11.1628828,12.5831562 12.1637957,11.3333355 L10,11.3333333 C9.66528197,11.3333333 9.38817799,11.0866583 9.34056171,10.7651818 L9.33333333,10.6666667 C9.33333333,10.3319486 9.5800084,10.0548447 9.90148489,10.0072284 L10,10 L13.3333333,10 C13.6680514,10 13.9451553,10.2466751 13.9927716,10.5681516 L14,10.6666667 L14,14 C14,14.3681898 13.7015232,14.6666667 13.3333333,14.6666667 C12.9986153,14.6666667 12.7215113,14.4199916 12.673895,14.0985151 L12.6666667,14 L12.6671114,12.7611802 C11.4416747,13.9632335 9.78012593,14.6666667 8,14.6666667 C4.31810167,14.6666667 1.33333333,11.6818983 1.33333333,8 C1.33333333,4.31810167 4.31810167,1.33333333 8,1.33333333 Z",
  id: "Combined-Shape",
  transform: "translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "
}))))))));

function SvgIconIcnRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B12DA6BA-A1D2-4E62-BDF5-DC8BD1F0C8E8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcnRefresh);
export default __webpack_public_path__ + "static/media/icon-icn-refresh.ff67911f.svg";
export { ForwardRef as ReactComponent };